import {
  Box,
  Container,
  Stack,
  Typography,
  Paper,
  Collapse,
  List,
  ListItem,
  ListItemText,
  Divider
} from "@mui/material";
import React, { useRef, useState } from "react";
import "./index.css";
import CustomButton from "../generic-components/Button/Button";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import { useNavigate } from "react-router-dom";


// Hierarchical services data with main categories and subcategories
const servicesData = [
  {
    id: 1,
    title: "Taxation Services",
    subtitle: "Our Services",
    imgSrc: "/assets/credit-record.png",
    bgClass: "taxation-bg",
    subCategories: [
      {
        id: "1-1",
        title: "Tax returns lodgement",
        description:
          "Our experienced team ensures accurate and timely tax return lodgements for individuals, Sole traders, Partnerships, Companies and Trusts across Australia. We handle complex tax scenarios, maximise deductions, and ensure compliance with the Australian Taxation Office (ATO). Whether it’s your personal tax return or corporate obligations, we make the process stress-free and efficient."
      },
      {
        id: "1-2",
        title: "Tax Planning",
        description:
          "Strategic tax planning to minimise liabilities. \nEffective tax planning can save your business thousands each year. Our tax experts provide tailored strategies to optimise your tax position, defer liabilities, and take advantage of all available concessions. We focus on proactive planning, ensuring your business grows while remaining fully compliant."
      },
      {
        id: "1-3",
        title: "Business Advisory",
        description:
          "We provide actionable insights to help your business thrive. From strategic planning to operational improvements, our advisory services are designed to enhance profitability, manage risk, and support sustainable growth. Partner with us to make informed decisions backed by financial expertise."
      }
    ]
  },

  {
    id: 2,
    title: "BAS & IAS Lodgements",
    subtitle: "BAS & IAS Lodgements",
    imgSrc: "/assets/Graph.png",
    bgClass: "bas-bg",
    subCategories: [
      {
        id: "2-1",
        title: "BAS Lodgements",
        description:
          "Reliable BAS Lodgement Services. \nStay compliant with the ATO with our accurate and timely Business Activity Statement (BAS) lodgement services. We ensure all GST, PAYG, and other reporting obligations are met on time, reducing stress and avoiding penalties."
      },
      {
        id: "2-2",
        title: "IAS Lodgements",
        description:
          "IAS Lodgements Made Simple. \nWe provide efficient Instalment Activity Statement (IAS) lodgement services, helping your business manage tax instalments and avoid unnecessary fines. Our team ensures your IAS is lodged accurately and on time, keeping your cash flow predictable and manageable."
      }
    ]
  },

  {
    id: 3,
    title: "Bookkeeping Services",
    subtitle: "Bookkeeping Services",
    imgSrc: "/assets/Payments.png",
    bgClass: "bookkeeping-bg",
    subCategories: [
      {
        id: "3-1",
        title: "Bookkeeping Services",
        description:
          "Our bookkeeping services keep your financial records organised, accurate, and up-to-date. We handle daily transaction recording, expense tracking, and reconciliation so you can focus on growing your business."
      },
      {
        id: "3-2",
        title: "Bank Reconciliation",
        description:
          "Comprehensive bank reconciliation services. \nWe reconcile your bank statements with your financial records to ensure accuracy and prevent errors. Regular bank reconciliation helps you maintain control over cash flow, detect discrepancies early, and make informed financial decisions."
      },
      {
        id: "3-3",
        title: "Cash Flow Management",
        description:
          "Optimise your cash flow\nOur cash flow management services help businesses maintain healthy liquidity, plan for expenses, and forecast future financial needs. By monitoring inflows and outflows, we help you make strategic decisions that support sustainable growth."
      },
      {
        id: "3-4",
        title: "Accounts Payable & Receivable",
        description:
          "Efficient Management of Accounts Payable and Receivable. \nWe manage your accounts payable and receivable to improve your cash flow, streamline invoicing, and reduce overdue payments. Our systems ensure your business maintains strong financial control and healthy supplier and client relationships."
      },
      {
        id: "3-5",
        title: "Regular Financial Reporting",
        description:
          "Insightful financial reporting for informed decisions\nStay informed with regular, customised financial reports. We provide profit and loss statements, cash flow statements, balance sheets, and management reports that help you track performance, identify trends, and make data-driven decisions."
      }
    ]
  },

  {
    id: 4,
    title: "Payroll & Superannuation",
    subtitle: "Payroll & Superannuation",
    imgSrc: "/assets/Payment.png",
    bgClass: "payroll-bg",
    subCategories: [
      {
        id: "4-1",
        title: "Payroll & Superannuation",
        description:
          "Reliable payroll and superannuation services. \nWe handle payroll processing, superannuation contributions, and compliance reporting, ensuring your employees are paid accurately and on time. Our payroll solutions reduce administrative burden and protect your business from regulatory risks."
      }
    ]
  },

  {
    id: 5,
    title: "Business Setup & Advisory",
    subtitle: "Business Setup & Advisory",
    imgSrc: "/assets/Agreement.png",
    bgClass: "business-bg",
    subCategories: [
      {
        id: "5-1",
        title: "Business Registration Services",
        description:
          "Starting a business in Australia is easier with our professional business registration services. We assist with ABN registration, GST setup, and registering for all relevant licenses, ensuring your business is legally compliant from day one."
      },
      {
        id: "5-2",
        title: "Business Structure Advice",
        description:
          "Tailored advice on business structures. \nChoosing the right business structure is crucial for tax efficiency and liability protection. Our experts provide guidance on sole trader, partnership, company, or trust structures, helping you make decisions aligned with your goals."
      },
      {
        id: "5-3",
        title: "Business Start-Up Services",
        description:
          "Supporting your business from the ground up. \nWe guide entrepreneurs through every step of starting a business—from business planning and registrations to setting up bookkeeping systems and compliance frameworks. Our goal is to give your new business the best chance for success."
      }
    ]
  }
];


function Service() {
  
  return (
    <Container maxWidth="xl" sx={{ my: 5 }}>
      <Typography className="services-main-heading" align="center">
        Our Services
      </Typography>
      <Typography align="center" className="services-sub-heading">
        Everything you need to stay compliant, organised, and focused on growth.
      </Typography>
      <ServiceCard />
    </Container>
  );
}

function ServiceCard() {
  // Track open/closed state for each main service category
    const navigate = useNavigate();
    const handleNavigation = (route) => {
      if (route) {
        navigate(route);
      }
    };

  const [openStates, setOpenStates] = useState(
    servicesData.reduce((acc, service) => {
      acc[service.id] = false;
      return acc;
    }, {})
  );

  const serviceCardRef = useRef(null);
  
  const handleToggle = (id) => {
    setOpenStates(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <>
      {servicesData.map((service) => (
        <React.Fragment key={service.id}>
          <Box
            ref={serviceCardRef}
            className={`service-card ${service.bgClass} ${openStates[service.id] ? "service-card-bg" : ""}`}
            sx={{ mt: 5, alignContent:'center' }}
          >
            <Stack direction="row" className="service-card-layout">
              {/* TEXT SIDE */}
              <Stack spacing={1}>
                <Typography className="service-card-title">
                  {service.title}
                </Typography>

                <Typography className="service-card-sub-title">
                  {service.subtitle}
                </Typography>
                <CustomButton
                  text={openStates[service.id] ? "Show Less" : "Show All"}
                  className="service-card-btn"
                  endIcon={
                    openStates[service.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />
                  }
                  onClick={() => handleToggle(service.id)}
                />
              </Stack>
              {openStates[service.id] && (
                <img
                  className="service-card-img"
                  src={service.imgSrc}
                  alt={service.title}
                />
              )}
            </Stack>
          </Box>

          <Collapse in={openStates[service.id]} timeout="auto" unmountOnExit>
            <Paper
              sx={{
                p: 3,
                mb: 4,
                backgroundColor: "#EDEDFF",
              }}
            >
              <List>
                {service.subCategories.map((subCategory, index) => (
                  <React.Fragment key={subCategory.id}>
                    <ListItem alignItems="flex-start" sx={{ flexDirection: "column", py: 2 }}>
                      <ListItemText
                        primary={
                          <Typography className="service-card-title">
                            {subCategory.title}
                          </Typography>
                        }
                        secondary={
                          <Typography className="service-card-sub-title" sx={{ my: 2 }}>
                            {subCategory.description}
                          </Typography>
                        }
                      />
                      <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start", mb: 2 }}>
                        <CustomButton
                          text="Book Now"
                          className="service-card-btn"
                          startIcon={<PermContactCalendarIcon />}
                          onClick={() => handleNavigation("/book-now")}
                          />
                      </Box>
                    </ListItem>
                    {index < service.subCategories.length - 1 && (
                      <Divider  />
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Paper>
          </Collapse>
        </React.Fragment>
      ))}
    </>
  );
}

export default Service;